(function (Drupal, $) {
  Drupal.behaviors.parallax = {
    attach: function attach(context) {
      if ($(context).find(".field__field-parallax-picture-slider").length) {
        // Clone first 3 image elements to use for wider screens
        $(".field-item__field-parallax-picture-slider").slice(0,3).clone().appendTo(".field__field-parallax-picture-slider");
        $(".field__field-parallax-picture-slider").paroller({ factor: 0.5, factorXs: 0.2, type: 'foreground', direction: 'horizontal' });
      }

      if ($(context).find(".field__field-partner-logos").length) {
        let enableParallax = false;
        $(window).on('resize scroll', function() {
          if ($(".field__field-partner-logos").isInViewport()) {
            if(enableParallax)
              return;
            $(".field__field-partner-logos").paroller({ factor: 0.2, factorXs: 0.2, type: 'foreground', direction: 'horizontal' });
            enableParallax = true
          } else {
            enableParallax = false;
          }
        });
      }

      $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
      };
    }
  }
})(Drupal, jQuery);
